<ul class="nav nav-tabs">
    <li class="nav-item" *ngFor="let tab of tabsArray; let sr = index" (click)="setTab(sr)">
      <div class="img-align">
        <img src="../../../../assets/images/codeEnhance.png" alt="">
      <a class="nav-link" [ngClass]="activatedTab == sr ? 'active' : '' ">{{tab}}</a>
      </div>
    </li>
  </ul>
